import { render, staticRenderFns } from "./ProposalGiftCard.vue?vue&type=template&id=bc32ff90"
import script from "./ProposalGiftCard.vue?vue&type=script&lang=js"
export * from "./ProposalGiftCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports